var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isMounted && _vm.isInnerActivated && _vm.hasAssessments
        ? _c(
            "tippy",
            {
              attrs: {
                arrow: "",
                theme: `${_vm.$theme.name}`,
                placement: "top",
              },
            },
            [
              _c("div", { staticClass: "card tippy-no-padding" }, [
                _c("div", { staticClass: "card-header p-1" }, [
                  _c("span", [_vm._v("Assessment History")]),
                ]),
                _c("div", { staticClass: "card-body p-1" }, [
                  _c("table", [
                    _c("thead", [
                      _c("tr", [
                        _c("td", {}),
                        _c("td", [
                          _c(
                            "span",
                            {
                              staticClass: "badge badge-sm",
                              class: [
                                `bg-${_vm.getColour("light")}`,
                                `text-${_vm.getColour("dark")}`,
                              ],
                            },
                            [_vm._v("Quoted")]
                          ),
                        ]),
                        _c("td"),
                        _c("td", [
                          _c(
                            "span",
                            {
                              staticClass: "badge badge-sm",
                              class: [
                                `bg-${_vm.getColour("light")}`,
                                `text-${_vm.getColour("dark")}`,
                              ],
                            },
                            [_vm._v("Authorised")]
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.itemAssessments, function (assessment) {
                        return _c(
                          "tr",
                          { key: _vm.getSupplementaryNo(assessment) },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "label-xxs",
                                class: [
                                  _vm.getAssessmentDiff(assessment) >= 0
                                    ? `text-${_vm.getColour("success")}`
                                    : `text-${_vm.getColour("danger")}`,
                                ],
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getSupplementaryNo(assessment) ===
                                          0,
                                        expression:
                                          "getSupplementaryNo(assessment) === 0",
                                      },
                                    ],
                                  },
                                  [_vm._v("Original")]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.getSupplementaryNo(assessment) >
                                          0,
                                        expression:
                                          "getSupplementaryNo(assessment) > 0",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      "Supp #" +
                                        _vm._s(assessment[0].subQuoteNo)
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            assessment[0]
                              ? _c("td", [
                                  assessment[0].isQuoteItemDeleted
                                    ? _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-sm",
                                            class: [
                                              `bg-${_vm.getColour("danger")}`,
                                              `text-${_vm.getColour("invert")}`,
                                            ],
                                          },
                                          [_vm._v(" Deleted ")]
                                        ),
                                      ])
                                    : assessment[0].reportOnly
                                    ? _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-sm",
                                            class: [
                                              `bg-${_vm.getColour("danger")}`,
                                              `text-${_vm.getColour("invert")}`,
                                            ],
                                          },
                                          [_vm._v(" Report Only ")]
                                        ),
                                      ])
                                    : _c("div", [
                                        _c("div", [
                                          _vm.isItemlabour
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "badge badge-sm",
                                                  class: [
                                                    `bg-${_vm.getColour(
                                                      "light"
                                                    )}`,
                                                    `text-${_vm.getColour(
                                                      "dark"
                                                    )}`,
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$filters.formatNumber(
                                                        assessment[0].hourValue
                                                      )
                                                    ) + "h "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "badge badge-sm",
                                              class: [
                                                `bg-${_vm.getColour("light")}`,
                                                `text-${_vm.getColour("dark")}`,
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$filters.formatCurrency(
                                                      _vm.totalValue(
                                                        assessment[0]
                                                      ),
                                                      _vm.$userInfo.locale
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                ])
                              : _c("td", [_c("span")]),
                            _c(
                              "td",
                              [
                                _c("authorised-icon", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasAssessments,
                                      expression: "hasAssessments",
                                    },
                                  ],
                                  staticClass: "authorised-icon",
                                  attrs: {
                                    diff: _vm.getAssessmentDiff(assessment),
                                  },
                                }),
                              ],
                              1
                            ),
                            assessment.length > 1
                              ? _c("td", [
                                  assessment[1].isQuoteItemDeleted
                                    ? _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-sm",
                                            class: [
                                              `bg-${_vm.getColour("danger")}`,
                                              `text-${_vm.getColour("invert")}`,
                                            ],
                                          },
                                          [_vm._v(" Deleted ")]
                                        ),
                                      ])
                                    : assessment[1].reportOnly
                                    ? _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-sm",
                                            class: [
                                              `bg-${_vm.getColour("danger")}`,
                                              `text-${_vm.getColour("invert")}`,
                                            ],
                                          },
                                          [_vm._v(" Report Only ")]
                                        ),
                                      ])
                                    : _c("div", [
                                        _c("div", [
                                          _vm.isItemlabour
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "badge badge-sm",
                                                  class: [
                                                    `bg-${_vm.getColour(
                                                      "light"
                                                    )}`,
                                                    `text-${_vm.getColour(
                                                      "dark"
                                                    )}`,
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$filters.formatNumber(
                                                        assessment[1].hourValue
                                                      )
                                                    ) + "h "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "badge badge-sm",
                                              class: [
                                                `bg-${_vm.getColour("light")}`,
                                                `text-${_vm.getColour("dark")}`,
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$filters.formatCurrency(
                                                      _vm.totalValue(
                                                        assessment[1]
                                                      ),
                                                      _vm.$userInfo.locale
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                ])
                              : _c("td", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-sm",
                                      class: `bg-${_vm.getColour("light")}`,
                                    },
                                    [_vm._v(_vm._s("Pending"))]
                                  ),
                                ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "supplement-container" },
        [
          _vm.hasAssessments
            ? _c("authorised-icon", {
                staticClass: "authorised-icon",
                attrs: { diff: _vm.authorisedValueDiff },
              })
            : _vm._e(),
          _c(
            "svg",
            {
              class: `fqi-svg-fill-${_vm.supplementaryIconColour}`,
              attrs: {
                version: "1.1",
                id: "Layer_1",
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                x: "0px",
                y: "0px",
                viewBox: "0 0 512 512",
                width: `${_vm.width}`,
                height: `${_vm.height}`,
                fill: "text-primary",
                "xml:space": "preserve",
              },
            },
            [
              _c("g", [
                _c("g", [
                  _c("path", {
                    attrs: {
                      d: "M511.957,185.214L512,15.045l-67.587,67.587l-7.574-7.574c-48.332-48.332-112.593-74.95-180.946-74.95\n            C114.792,0.107,0,114.901,0,256s114.792,255.893,255.893,255.893S511.785,397.099,511.785,256h-49.528\n            c0,113.79-92.575,206.365-206.365,206.365S49.528,369.79,49.528,256S142.103,49.635,255.893,49.635\n            c55.124,0,106.947,21.467,145.925,60.445l7.574,7.574l-67.58,67.58L511.957,185.214z",
                    },
                  }),
                ]),
              ]),
              _c(
                "text",
                {
                  attrs: {
                    x: "50%",
                    y: "50%",
                    "text-anchor": "middle",
                    "font-size": "300",
                    dy: ".35em",
                  },
                },
                [_vm._v(_vm._s(_vm.supplementaryNo))]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }